export const siteHexColor = (color: string): string => {
  return color.startsWith("#") ? color : `#${color}`;
};
